import React from 'react';
import About from '../defaults/About';

export default (props) => {
  return (
    <About />
  );
}
